import React, {useState, useRef} from 'react';
import './about.css';
import { Blog, Brand, Info, CTA } from '../../@/components';
import play from '../../main_assets/play.png';
import { Features } from '../../containers';
import BlurhashImg from '../../@/components/Image/BlurhashImg';
// import about from '../../main_assets/about.png'

const About = () => {
  const [playing, setPlaying] = useState([false, false, false]);
  const videoRefs = [useRef(null), useRef(null), useRef(null)]; 

  const handlePlayPause = (index) => {
    return () => {
      if (videoRefs[index].current) {
        const updatedPlaying = [...playing];
        updatedPlaying[index] = !playing[index];
        setPlaying(updatedPlaying);

        const video = videoRefs[index].current;

        if (!playing[index] || video.ended) {
          video.play();
        } else {
          video.pause();
        }
      }
    };
  };

  const handleVideoEnded = (index) => () => {
    const updatedPlaying = [...playing];
    updatedPlaying[index] = false;
    setPlaying(updatedPlaying);
  };
  
  return (
    <div className="about" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <div>
        {/* <div className="gpt3__header-image" style={{ position: 'relative' }}>
          <img src={} alt="Header Background" />
          
          <div className="about-us-text">
            <p> Industrial Design</p>
          </div>
        </div> */}
        <Features />
      </div>
    </div>
  )
}
 
export default About